import React, { useRef, useState } from "react";
import { api, resolveImg } from "../lib/api";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ImageUpload = ({ value, onChange, label, testid }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {label && <label className="text-xs uppercase tracking-wider text-brand-muted">{label}</label>}
      <div className="mt-2 flex items-center gap-4">
        <div className="h-16 w-16 rounded-xl overflow-hidden bg-brand-surface border border-brand-line shrink-0 flex items-center justify-center">
          {value ? <img src={resolveImg(value)} alt="" className="h-full w-full object-cover" /> : <span className="text-brand-muted text-xs">—</span>}
        </div>
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          data-testid={testid}
          className="inline-flex items-center gap-2 rounded-lg border border-brand-line hover:border-brand-gold px-4 py-2 text-sm transition-colors"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
          {loading ? "Uploading…" : "Upload"}
        </button>
        <input ref={inputRef} type="file" accept="image/*" onChange={handle} className="hidden" />
      </div>
    </div>
  );
};
